// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForwardFilledSvg from "@ant-design/icons-svg/es/asn/ForwardFilled";
import AntdIcon from '../components/AntdIcon';

var ForwardFilled = function ForwardFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForwardFilledSvg
  }));
};

ForwardFilled.displayName = 'ForwardFilled';
export default React.forwardRef(ForwardFilled);